<template>
  <div>
    <div style="height: 4.8rem;"></div>
    <div class="bottom-button">
      <slot></slot>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    label: {
      type: String,
      default: '提交'
    }
  },
  data() {
    return {}
  },
  created() {},
  methods: {}
}
</script>
<style lang="less" scoped>
.bottom-button {
  background: white;
  width: 100%;
  padding: 0.6rem;
  border-top: 1px solid #ededed;
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
  /deep/ .van-button {
    width: 100%;
    margin: 0 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/BottomButton.vue